class HeaderPrimary {
  private headerElement?: HTMLElement | null;
  private links: NodeListOf<HTMLAnchorElement>;
  private readonly homeUrl: string;

  constructor() {
    this.headerElement = document.querySelector<HTMLElement>('header');
    this.links = document.querySelectorAll<HTMLAnchorElement>('.header-primary__link');
    this.homeUrl = window.location.origin;
    this.links.forEach(link => {
      link.addEventListener('click', this.handleClick.bind(this));
    });
    window.addEventListener('scroll', this.handleScroll.bind(this));

    this.handleScroll();
    window.addEventListener('load', this.handleInitialHash.bind(this));
  }

  private handleScroll(): void {
    if (!this.headerElement) return;

    const headerHeight = this.headerElement.offsetHeight;
    const scrollPosition = window.scrollY;
    if (scrollPosition > headerHeight) {
      this.headerElement.classList.add('scrolled');
    } else {
      this.headerElement.classList.remove('scrolled');
    }
  }

  private scrollToId(targetId: string): void {
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const windowWidth = window.innerWidth;
      const headerElement = document.querySelector<HTMLElement>('header');
      const headerHeight = headerElement ? headerElement.offsetHeight : 0;

      if (windowWidth > 1025) {
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerHeight;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });

      } else {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }

  private handleInitialHash(): void {
    const hash = window.location.hash;
    if (hash) {
      this.scrollToId(hash);
    }
  }

  private handleClick(event: Event): void {
    const link = event.currentTarget as HTMLAnchorElement;
    const targetHash = new URL(link.href).hash;
    if (!targetHash) {
      return;
    }

    const currentUrl = window.location.origin + window.location.pathname.replace(/\/$/, '');
    const isHomePage = currentUrl === this.homeUrl;

    if (isHomePage) {
      console.log('hoomee')
      event.preventDefault();
      this.scrollToId(targetHash);
    } else {
      console.log('pas hoomee')
      event.preventDefault();
      const targetUrl = this.homeUrl + targetHash;
      window.location.href = targetUrl;
    }
  }
}

export const header = new HeaderPrimary();